import CONSTANTS from '../constants';
import querystring from 'querystring';
import moment from 'moment';

export function getFichaUrl(slug) {
    return `${CONSTANTS.HOME}/${slug}`;
}

export function getNomeTipoFicha(tipoSlug, plural = false) {
    for (let tipo of CONSTANTS.TIPOS_DE_FICHA) {
        if (tipo.slug === tipoSlug) {
            return (plural) ? tipo.plural : tipo.name;
        }
    }
}

export function getCorTipoFicha(tipoSlug) {
    for (let tipo of CONSTANTS.TIPOS_DE_FICHA) {
        if (tipo.slug === tipoSlug) {
            return tipo.cor;
        }
    }
}

export function getNomeTermoTaxonomia(taxonomia, taxSlug, opcoes) {
    for (let tax of opcoes[taxonomia]) {
        if (tax.slug === taxSlug) {
            return tax.label;
        }
    }
    return "";
}

export function getTermoTaxonomia(taxonomia, targetTermSlug, opcoes) {
    let taxonomias = [taxonomia];
    if (['localizacao', 'sujeito'].includes(taxonomia)) {
        for (let taxFilter of CONSTANTS.TAXONOMIAS_FILTROS) {
            if (taxFilter.id === taxonomia) {
                taxonomias = taxFilter.relatedTaxes;
                break;
            }
        }
    }
    for (let taxonomiaSlug of taxonomias) {
        for (let term of opcoes[taxonomiaSlug]) {
            if (term.slug === targetTermSlug) {
                if (taxonomias.length > 0) {
                    term.tax = taxonomiaSlug;
                }
                return term;
            }
        }
    }
    return "";
}

export function ordena(campo) {
    var sortOrder = 1;
    if(campo[0] === "-") {
        sortOrder = -1;
        campo = campo.substr(1);
    }
    return function (a,b) {
        var result = (a[campo] < b[campo]) ? -1 : (a[campo] > b[campo]) ? 1 : 0;
        return result * sortOrder;
    }
}

export function ordenaSoma(campo1, campo2) {
    var sortOrder = 1;
    if(campo1[0] === "-") {
        sortOrder = -1;
        campo1 = campo1.substr(1);
    }
    return function (a,b) {
        var result = (a[campo1]+a[campo2] < b[campo1]+b[campo2]) ? -1 : (a[campo1]+a[campo2] > b[campo1]+b[campo2]) ? 1 : 0;
        return result * sortOrder;
    }
}

export function ordenaLista(fichas, campo) {
    return fichas.sort(ordena(campo));
}

export function getIntervaloFichas(fichas, isMobile) {
    const steps = (isMobile)
        ? CONSTANTS.INTERVALO_STEPS.mobile
        : CONSTANTS.INTERVALO_STEPS.desktop;

    let min = 0;
    let max = 0;
    for (let tipo of Object.keys(fichas)) {
        for (let ficha of fichas[tipo]) {
            const date = moment(ficha.post_date).valueOf();
            if (date < min || min === 0) {
                min = date;
            }
            if (date > max || max === 0) {
                max = date;
            }
        }
    }

    const step = Math.floor((max - min) / steps);
    let format = "YYYY";
    if (moment.duration(step).asYears() < 1) {
        format = "MMM YYYY";
    }
    if (moment.duration(step).asMonths() < 1) {
        format = "DD/MM/YYYY"
    }

    const marks = {};
    for (let i = 0; i <= steps; i++) {
        const stepDate = min + (i * step);
        marks[stepDate] = moment(stepDate).format(format);
    }

    return {
        min: min,
        max: max,
        step: step,
        marks: marks,
        format: format
    };
}

export function getResultadosPorTipo(ficha, tipo, taxonomia, resultados) {
    if (!ficha.tax.hasOwnProperty(taxonomia)) {
        return resultados;
    }
    for (let taxSlug of ficha.tax[taxonomia]) {
        if (!resultados.hasOwnProperty(taxSlug)) {
            resultados[taxSlug] = {};
        }
        if (!resultados[taxSlug].hasOwnProperty(tipo)) {
            for (let t of CONSTANTS.TIPOS_DE_FICHA) {
                resultados[taxSlug][t.slug] = 0;
            }
        }
        resultados[taxSlug][tipo] += 1;
    }
    return resultados;
}

export function getResultados(ficha, taxonomia, resultados) {
    if (!ficha.tax.hasOwnProperty(taxonomia)) {
        return resultados;
    }
    // console.log(ficha.tax[taxonomia]);
    for (let taxSlug of ficha.tax[taxonomia]) {
        if (!resultados.hasOwnProperty(taxSlug)) {
            resultados[taxSlug] = 0;
        }
        resultados[taxSlug] += 1;
    }
    return resultados;
}

export function getResultadosMeta(ficha, meta, resultados) {
    if (!ficha.meta.hasOwnProperty(meta)) {
        return resultados;
    }
    // console.log(ficha.tax[taxonomia]);
    for (let metaSlug of ficha.meta[meta]) {
        if (!resultados.hasOwnProperty(metaSlug)) {
            resultados[metaSlug] = 0;
        }
        resultados[metaSlug] += 1;
    }
    return resultados;
}

export function getResultadosMetaFamilias(ficha, meta, resultadosAmeacadas, resultadosDespejadas) {
    if (!ficha.meta.hasOwnProperty(meta)) {
        return [resultadosAmeacadas, resultadosDespejadas];
    }
    // console.log(ficha.tax[taxonomia]);
    for (let metaSlug of ficha.meta[meta]) {
        if (!resultadosAmeacadas.hasOwnProperty(metaSlug)) {
            resultadosAmeacadas[metaSlug] = 0;
        }
        if (!resultadosDespejadas.hasOwnProperty(metaSlug)) {            
            resultadosDespejadas[metaSlug] = 0;
        }
        resultadosAmeacadas[metaSlug] += Number(ficha.meta['numero_de_familias_ameacadas']) || 0;
        resultadosDespejadas[metaSlug] += Number(ficha.meta['numero_de_familias_despejadas']) || 0;
    }
    return [resultadosAmeacadas, resultadosDespejadas];
}

export function getResultadosFamilias(ficha, taxonomia, resultadosAmeacadas, resultadosDespejadas) {
    if (!ficha.tax.hasOwnProperty(taxonomia)) {
        return [resultadosAmeacadas, resultadosDespejadas];
    }
    for (let taxSlug of ficha.tax[taxonomia]) {
        if (!resultadosAmeacadas.hasOwnProperty(taxSlug)) {
            resultadosAmeacadas[taxSlug] = 0;
        }
        if (!resultadosDespejadas.hasOwnProperty(taxSlug)) {
            resultadosDespejadas[taxSlug] = 0;
        }
        resultadosAmeacadas[taxSlug] += Number(ficha.meta['numero_de_familias_ameacadas']) || 0;
        resultadosDespejadas[taxSlug] += Number(ficha.meta['numero_de_familias_despejadas']) || 0;
    }
    return [resultadosAmeacadas, resultadosDespejadas];
}

export function getResultadosFamiliasTotal(ficha, taxonomia, resultados) {
    if (!ficha.tax.hasOwnProperty(taxonomia)) {
        return resultados;
    }
    for (let taxSlug of ficha.tax[taxonomia]) {
        if (!resultados.hasOwnProperty(taxSlug)) {
            resultados[taxSlug] = 0;
        }
        resultados[taxSlug] += Number(ficha.meta['numero_de_familias_ameacadas']) || 0;
        resultados[taxSlug] += Number(ficha.meta['numero_de_familias_despejadas']) || 0;
    }
    return resultados;
}

export function getResultadosFamiliasTotal2D(ficha, taxonomia1, taxonomia2, resultados) {
    if (!ficha.tax.hasOwnProperty(taxonomia1) || !ficha.tax.hasOwnProperty(taxonomia2)) {
        return resultados;
    }
    for (let taxSlug1 of ficha.tax[taxonomia1]) {
        if (!resultados.hasOwnProperty(taxSlug1)) {
            resultados[taxSlug1] = [];
        }
        for (let taxSlug2 of ficha.tax[taxonomia2]) {
          if (!resultados[taxSlug1].hasOwnProperty(taxSlug2)) {
              resultados[taxSlug1][taxSlug2] = 0;
          }
          resultados[taxSlug1][taxSlug2] += Number(ficha.meta['numero_de_familias_ameacadas']) || 0;
          resultados[taxSlug1][taxSlug2] += Number(ficha.meta['numero_de_familias_despejadas']) || 0;
        }
    }
    return resultados;
}

export function getResultadosFamiliasTotal2DMeta(ficha, taxonomia, meta, resultados) {
    if (!ficha.tax.hasOwnProperty(taxonomia) || !ficha.meta.hasOwnProperty(meta)) {
        return resultados;
    }
    for (let taxSlug of ficha.tax[taxonomia]) {
        if (!resultados.hasOwnProperty(taxSlug)) {
            resultados[taxSlug] = [];
        }
        for (let metaSlug of ficha.meta[meta]) {
          if (!resultados[taxSlug].hasOwnProperty(metaSlug)) {
              resultados[taxSlug][metaSlug] = 0;
          }
          resultados[taxSlug][metaSlug] += Number(ficha.meta['numero_de_familias_ameacadas']) || 0;
          resultados[taxSlug][metaSlug] += Number(ficha.meta['numero_de_familias_despejadas']) || 0;
        }
    }
    return resultados;
}

export function preparaParaBusca(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    // str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return str.normalize("NFD").replace(/\p{Diacritic}/gu, "").replace(/\s+/g, '-').toLowerCase();
}

export function getFiltersFromURL(searchParams, opcoes) {
    let filters = CONSTANTS.emptyFilters;

    for (let filterField of Object.keys(filters)) {
        if (typeof filters[filterField] === 'string') {
            const filterValue = searchParams.get(filterField);
            if (filterValue) {
                filters[filterField] = filterValue;
            }
            continue;
        }

        if (filterField === 'tipoGroup') {
            const filterValues = searchParams.getAll(`tipoGroup[]`);
            for (let i = 0; i < filters.tipoGroup.length; i++) {
                 filters.tipoGroup[i].active = (filterValues.includes(filters.tipoGroup[i].id) || filterValues.length === 0);
            }
            continue;
        }

        if (filterField === 'intervaloDataValue') {
            const filterValues = searchParams.getAll(`intervaloDataValue[]`);
            filters[filterField] = filterValues.map((filterValue) => {return parseInt(filterValue)});
            continue;
        }

        const filterValues = searchParams.getAll(`${filterField}[]`);
        if (filterValues.length > 0) {
            filters[filterField] = filterValues.map((filterValue) => {
                return getTermoTaxonomia(filterField, filterValue, opcoes);
            });
        }
    }
    return filters;
}

export function hashCode(target) {
    if (target === null) {
        return '';
    }
    const s = (typeof target === 'string')
        ? target
        : JSON.stringify(target);
    return s.split('').reduce((a,b) => (((a << 5) - a) + b.charCodeAt(0))|0, 0);
}

export function buildFilterParams(filters) {
    let filterParams = {};
    if (filters.hasOwnProperty('tipoGroup')) {
        const tipoGroup = filters.tipoGroup.map((tipo) => {
            return (tipo.active)
            ? tipo.id
            : null;
        }).filter((tipo) => {return tipo != null});
        if (tipoGroup.length < filters.tipoGroup.length) {
            filterParams['tipoGroup[]'] = tipoGroup;
        }
    }

    for (let filterField of Object.keys(filters)) {
        if (filterField !== 'tipoGroup' && filters.hasOwnProperty(filterField)) {
            if (typeof filters[filterField] === 'string') {
                if (!['', '-1'].includes(filters[filterField])) {
                    filterParams[filterField] = filters[filterField];
                }
                continue;
            }

            if (filters[filterField].length > 0) {
                filterParams[`${filterField}[]`] = filters[filterField].map((filter) => {
                    if (typeof filter !== 'object') {
                        return filter;
                    }
                    return filter.slug;
                });
            }
        }
    }
    return filterParams;
}

export function updateUrl(history, filters) {
    const filterParams = buildFilterParams(filters);
    history.push('?' + querystring.stringify(filterParams));
}
